import React, { useState } from 'react';
import { useAuthnMe, isAuthnMeConfigured } from '../AuthnMeProvider';

/**
 * OAuth sign-in button and user menu. Shown on home page when AuthnMe is configured.
 */
export function LoginButton() {
  const { isAuthenticated, isLoading, user, login, logout, hasEverLoggedIn } = useAuthnMe();
  const [showMenu, setShowMenu] = useState(false);

  if (!isAuthnMeConfigured()) return null;

  if (isLoading) {
    return (
      <div className="login-button-container">
        <div className="login-button loading">
          <span className="login-spinner" />
        </div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <div className="login-button-container">
        <button type="button" className="user-menu-button" onClick={() => setShowMenu(!showMenu)}>
          <div className="user-avatar">{user.email ? user.email[0].toUpperCase() : 'U'}</div>
          <span className="user-email">{user.email || 'User'}</span>
          <svg className="dropdown-arrow" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
        {showMenu && (
          <>
            <div className="menu-backdrop" onClick={() => setShowMenu(false)} role="presentation" />
            <div className="user-menu">
              <div className="user-menu-header">
                <div className="user-avatar large">{user.email ? user.email[0].toUpperCase() : 'U'}</div>
                <div className="user-info">
                  <span className="user-name">{user.email || 'User'}</span>
                </div>
              </div>
              <div className="user-menu-divider" />
              <a href="/customer" className="user-menu-item">
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
                </svg>
                Dashboard
              </a>
              <button type="button" onClick={logout} className="user-menu-item logout">
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
                </svg>
                Sign Out
              </button>
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="login-button-container">
      <button type="button" className="login-button" onClick={() => login()}>
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
        <span>{hasEverLoggedIn ? 'Sign In' : 'Sign Up'}</span>
      </button>
    </div>
  );
}

export default LoginButton;
